import { FormGroup, Input, Label } from "reactstrap";
import { ChangeEvent, KeyboardEvent } from "react";
import RequiredField from "../RequiredField";

interface IProps {
  fieldName: string;
  fieldValue: string;
  labelName?: string;
  requiredField?: boolean;
  showLabel?: boolean;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
  labelClass?: string;
  placeholder?: string;
  className?: string;
  skipFormGroup?: boolean;
  disabled?: boolean;
}

export const TimePicker = ({
  fieldName,
  fieldValue,
  labelName,
  requiredField = false,
  showLabel = true,
  handleChange,
  onKeyPress = (event) => {},
  labelClass = "",
  placeholder = "",
  className = "",
  skipFormGroup = false,
  disabled = false,
}: IProps) => {
  const field = (
    <Input
      type="time"
      name={fieldName}
      id={fieldName}
      value={fieldValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      onKeyPress={onKeyPress}
    />
  );

  return skipFormGroup ? (
    field
  ) : (
    <FormGroup className={className}>
      {showLabel && (
        <Label className={labelClass}>
          {labelName} {requiredField ? <RequiredField /> : null}
        </Label>
      )}
      {field}
    </FormGroup>
  );
};
